import React from 'react';
import s from './style.module.css';
import { URL } from '@Pages/url';

// 全ページ共通の「重要なお知らせ」帯（ヘッダー直下）（issue #2204）
// 掲載終了時は呼び出し3箇所すべてを外す: Components/pc/page/view.tsx、Components/sp/page/view.tsx、
// Pages/Top/pc/index.tsx（TOP(PC)はPageを使わずHeaderを直接呼ぶため個別に呼んでいる）。
// `grep -rn ImportantNoticeBar app/javascript` で残りがないことを確認する
// 文言は「影響を受けないことを確認」にとどめ、サイトの技術構成には触れない
const NOTICE_NEWS_ID = 1645;

type Props = {
    // SPレイアウト用（PC/SPはUAで出し分けているためメディアクエリでなくpropで切り替える）
    isSp?: boolean;
};

export const ImportantNoticeBar = (props: Props) => {
    return (
        <div className={`${s.notice_bar} ${props.isSp ? s.sp : ''}`} role='region' aria-label='重要なお知らせ'>
            <span className={s.tag}>重要</span>
            報道されているPHPの脆弱性について、当社ウェブサイトは影響を受けないことを確認しています。
            <a className={s.link} href={`${URL.INFO_NEWS}/${NOTICE_NEWS_ID}`}>
                詳細はこちら
            </a>
        </div>
    );
};

export default ImportantNoticeBar;
